import { IntentionsTypes } from './constants';

const getIntention: (path: string) => number | null = (path) => {
  const pathList = path.split('/');

  if (pathList.length === 0) {
    return null;
  }

  const [lastPathChunk] = pathList.slice(-1);

  const intentionId = parseInt(lastPathChunk, 10);

  if (intentionId !== IntentionsTypes.Loading && intentionId !== IntentionsTypes.Unloading) {
    return null;
  }

  return intentionId;
};

export const pathService = {
  getIntention,
};
